module.exports = __webpack_public_path__ + "static/smoothweb-text-ab81ae235732bc6ba416f298e3a4c6d7.svg";